var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailEditor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.294,
    height: 22.431,
    viewBox: "0 0 32.294 22.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.e{fill:none;}.a{stroke:#222;stroke-linecap:round;stroke-width:1.5px;}.a,.c{stroke-linejoin:round;stroke-miterlimit:10;}.b{fill:#222;}.c,.e{stroke:#fff;stroke-width:1.2px;}.d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.793)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M533.508,409.86l-22.375-.067",
    transform: "translate(-511.132 -402.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M534.107,421.215v14.43H511.753V420.761",
    transform: "translate(-511.753 -413.965)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M511.753,421.8l10.934,7.989,10.934-8.363",
    transform: "translate(-511.498 -414.291)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(16.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14174.5 17571.621)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M740.278,308.092l.859-2.328,5.544-4.927,1.188,1.256.975,1.03-5.388,5.071-2.318.806",
    transform: "translate(-14893.997 -17870.139)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M739.712,332.7l-3.114,1.027,1.151-3.258",
    transform: "translate(-14891.766 -17893.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M740.759,310.527l2.195,2.526",
    transform: "translate(-14893.461 -17875.039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailEditor);
export default __webpack_public_path__ + "static/media/mail_editor.00ffede007c6db5e37bcfc734aaf7bd8.svg";
export { ForwardRef as ReactComponent };